import { offlineAccount as PosOfflineAccount } from './offline-account.trigger';

export const offlineAccount = PosOfflineAccount;
